//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ReactElement } from 'react'

import { EthAddr } from '@shared/SchemaTypes'

export default function LenderTransferSource(_props: { poolAddr: EthAddr; poolName: string }): ReactElement {
  throw new Error('TODOV5 Not implemented')
  // const { poolAddr } = props
  // const dispatch = useOtDispatch()
  // const [pooCrossChainTransferCTO, setPooCrossChainTransferCTO] = React.useState<PoolCrossChainTransferCTO | undefined>(
  //   undefined
  // )
  // const poolBaseOverviewCTO = useOtSelector(
  //   (state: OtStoreState) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO]
  // )

  // const { chainId, restAPIKey, serverApiBaseUrl, providerReadOnly, signer } = useOtSelector(
  //   (state: OtStoreState) => state.chainState as ChainStateDeploymentConfigured
  // )
  // useEffect(() => {
  //   if (poolAddr && chainId && serverApiBaseUrl && providerReadOnly) {
  //     poolCrossChainTransferFetch(serverApiBaseUrl, restAPIKey, poolAddr).then(
  //       (_pooCrossChainTransferCTO: PoolCrossChainTransferCTO | undefined) => {
  //         setPooCrossChainTransferCTO(_pooCrossChainTransferCTO)
  //       }
  //     )
  //   }
  // }, [chainId, serverApiBaseUrl, providerReadOnly, poolAddr])

  // const handleCancel = (): void => {
  //   const event = new Event('modalClose')
  //   window.dispatchEvent(event)
  // }
  // if (!pooCrossChainTransferCTO) {
  //   return <Typography variant="h2">Loading ....</Typography>
  // }

  // logOT.info('pooCrossChainTransferCTO', pooCrossChainTransferCTO)
  // const handleTransferRequest = async (): Promise<void> => {
  //   updatePoolCrossChainTransfer()
  //     .then(() => {
  //       const event = new Event('modalClose')
  //       window.dispatchEvent(event)
  //     })
  //     .catch((e) => {
  //       logOT.error(e)
  //     })

  //   async function updatePoolCrossChainTransfer() {
  //     const sourcePoolCrossTrainTransferCTO: PoolCrossChainTransferCTO | undefined = await poolCrossChainTransferFetch(
  //       serverApiBaseUrl,
  //       restAPIKey,
  //       poolAddr
  //     )
  //     if (!sourcePoolCrossTrainTransferCTO) {
  //       throw new Error('sourcePoolCrossTrainTransferCTO is undefined')
  //     }

  //     const destDeployment = DEPLOYMENT_CONFIGURATIONS.find(
  //       (config: DeploymentConfiguration) =>
  //         config.deploymentName === sourcePoolCrossTrainTransferCTO.destinationDeploymentName
  //     )
  //     logOT.info('destDeployment', destDeployment, sourcePoolCrossTrainTransferCTO.destinationDeploymentName)
  //     if (!destDeployment?.serverApiBaseUrl) {
  //       throw new Error('sourcePoolCrossTrainTransferCTO is Misconfigured')
  //     }
  //     const destPoolCrossTrainTransferCTO: PoolCrossChainTransferCTO | undefined = await poolCrossChainTransferFetch(
  //       destDeployment?.serverApiBaseUrl,
  //       restAPIKey,
  //       sourcePoolCrossTrainTransferCTO.destinationPoolAddr
  //     )
  //     if (!destPoolCrossTrainTransferCTO) {
  //       throw new Error('destPoolCrossTrainTransferCTO is undefined')
  //     }

  //     if (poolAddr && signer) {
  //       sourcePoolCrossTrainTransferCTO.transferStep = TransferStepNumbers.Source_Burn_Pending
  //       sourcePoolCrossTrainTransferCTO.transferStepName = TransferStepNames.Source_Burn_Pending

  //       await poolCrossChainTransferPut(
  //         serverApiBaseUrl,
  //         restAPIKey,
  //         destDeployment.serverApiBaseUrl,
  //         destDeployment.restAPIKey,
  //         sourcePoolCrossTrainTransferCTO
  //       )

  //       try {
  //         if (poolBaseOverviewCTO?.poolType === PoolTypeEnum.Term) {
  //           const pool = new ethers.Contract(poolAddr, PoolAbi, signer)
  //           logOT.info(
  //             'crossChainTransferBurnSource',
  //             poolAddr,
  //             destPoolCrossTrainTransferCTO.destinationWalletAddr,
  //             destPoolCrossTrainTransferCTO.amount,
  //             BigInt(destPoolCrossTrainTransferCTO.amount)
  //           )

  //           const tx = await (pool.connect(signer) as unknown as Pool).crossChainTransferBurnSource(
  //             BigInt(destPoolCrossTrainTransferCTO.amount).toString()
  //           )
  //           await tx.wait(0)
  //           logOT.info('crossChainTransferBurnSourcesuccess')
  //         } else {
  //           const pool = new ethers.Contract(poolAddr, PoolFlexAbi, signer)
  //           const tx = await (pool.connect(signer) as unknown as Pool).crossChainTransferBurnSource(
  //             BigInt(destPoolCrossTrainTransferCTO.amount).toString()
  //           )
  //           await tx.wait(0)
  //         }
  //       } catch (e: any) {
  //         const alertCTO: AlertCTO = alertCTOFromError(e, ActivityEnum.ChainTransfer)
  //         dispatch(alertActions.addAlert(alertCTO))
  //         throw e
  //       }
  //     } else {
  //       throw new Error('poolControllerAddr or signer is undefined')
  //     }
  //     sourcePoolCrossTrainTransferCTO.transferStep = TransferStepNumbers.Source_Burned
  //     sourcePoolCrossTrainTransferCTO.transferStepName = TransferStepNames.Source_Burned

  //     await poolCrossChainTransferPut(
  //       serverApiBaseUrl,
  //       restAPIKey,
  //       destDeployment.serverApiBaseUrl,
  //       destDeployment.restAPIKey,
  //       sourcePoolCrossTrainTransferCTO
  //     )
  //   }
  // }

  // return (
  //   <Box py={2} px={2} width={500}>
  //     <Grid container spacing={6}>
  //       <Grid sx={{ marginTop: 2 }} item xs={12}>
  //         <SectionHeader>Source</SectionHeader>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Chain ID
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {chainId}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Vault Address
  //         </Typography>
  //         <AddressPill addr={poolAddr} />
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Account
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           <AddressPill addr={pooCrossChainTransferCTO.sourceWalletAddr} />
  //         </Typography>
  //       </Grid>
  //       <Grid sx={{ marginTop: 2 }} item xs={12}>
  //         <SectionHeader>Destination</SectionHeader>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Destination Chain ID
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {pooCrossChainTransferCTO.destinationChainId}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Destination Vault Address
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           <AddressPill addr={pooCrossChainTransferCTO?.destinationPoolAddr} />
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Amount
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {erc20WeiToCommaDecString(pooCrossChainTransferCTO.amount)} {poolBaseOverviewCTO?.liquidityTokenSymbol}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Destination Account
  //         </Typography>
  //         <AddressPill addr={pooCrossChainTransferCTO?.destinationWalletAddr} />
  //       </Grid>
  //       <Grid item xs={12} sm={12}>
  //         <ButtonAction
  //           data-testid={'TransferRequest'}
  //           sx={{ marginRight: '16px' }}
  //           variant={'primary'}
  //           onClick={handleTransferRequest}
  //         >
  //           Transfer Request
  //         </ButtonAction>

  //         <ButtonAction variant={'tertiary'} onClick={handleCancel}>
  //           Cancel
  //         </ButtonAction>
  //       </Grid>
  //     </Grid>
  //   </Box>
  // )
}
